import type { DashEnergyWidgetTypes } from 'src/components/Dashboards/dash-energy-types';

/** Display versions for energy dashboard widgets (dev overlay). Keep in sync with each card's HTML comment. */
export const ENERGY_WIDGET_VERSIONS: Record<DashEnergyWidgetTypes, string> = {
	dashEnergyInfo: '1.0',
	dashEnergyKpiLive: '1.0',
	dashEnergyKpiPeriod: '1.0',
	dashEnergyTopConsumers: '1.0',
	dashEnergyConsumerMix: '1.0',
	dashEnergyRoomChart: '1.0',
	dashEnergyFlow: '1.0',
	dashEnergyHeatmap: '1.0',
	dashEnergyPeak: '1.0',
	dashEnergyInsights: '1.0',
	dashEnergyGeneration: '1.0',
	dashEnergyPvDistribution: '1.0',
	dashEnergyTariff: '1.0',
	dashEnergyPhase: '1.0',
	dashEnergyEnvironmental: '1.0',
	dashEnergyDeviceTrend: '1.0',
	dashEnergyRoomCharts: '1.0',
	dashEnergyRoomDistribution: '1.0',
};

/** Dedicated dashboard widget card filenames shown in the version overlay. */
export const ENERGY_WIDGET_COMPONENTS: Record<DashEnergyWidgetTypes, string> = {
	dashEnergyInfo: 'DashEnergyInfoWidgetCard.svelte',
	dashEnergyKpiLive: 'DashEnergyKpiLiveWidgetCard.svelte',
	dashEnergyKpiPeriod: 'DashEnergyKpiPeriodWidgetCard.svelte',
	dashEnergyTopConsumers: 'DashEnergyTopConsumersWidgetCard.svelte',
	dashEnergyConsumerMix: 'DashEnergyConsumerMixWidgetCard.svelte',
	dashEnergyRoomChart: 'DashEnergyRoomChartWidgetCard.svelte',
	dashEnergyFlow: 'DashEnergyFlowWidgetCard.svelte',
	dashEnergyHeatmap: 'DashEnergyHeatmapWidgetCard.svelte',
	dashEnergyPeak: 'DashEnergyPeakWidgetCard.svelte',
	dashEnergyInsights: 'DashEnergyInsightsWidgetCard.svelte',
	dashEnergyGeneration: 'DashEnergyGenerationWidgetCard.svelte',
	dashEnergyPvDistribution: 'DashEnergyPvDistributionWidgetCard.svelte',
	dashEnergyTariff: 'DashEnergyTariffWidgetCard.svelte',
	dashEnergyPhase: 'DashEnergyPhaseWidgetCard.svelte',
	dashEnergyEnvironmental: 'DashEnergyEnvironmentalWidgetCard.svelte',
	dashEnergyDeviceTrend: 'DashEnergyDeviceTrendWidgetCard.svelte',
	dashEnergyRoomCharts: 'DashEnergyRoomChartsWidgetCard.svelte',
	dashEnergyRoomDistribution: 'DashEnergyRoomDistributionWidgetCard.svelte',
};

export const getEnergyWidgetVersion = (type: string): string | undefined =>
	ENERGY_WIDGET_VERSIONS[type as DashEnergyWidgetTypes];

export const getEnergyWidgetComponentName = (type: string, widgetId?: string): string | undefined => {
	if (type === 'dashEnergyInsights' && widgetId?.startsWith('devices-explore')) {
		return 'DashEnergyExploreWidgetCard.svelte';
	}

	return ENERGY_WIDGET_COMPONENTS[type as DashEnergyWidgetTypes];
};
